import React, { useEffect, useState } from 'react';

import DetailHeader from '../Detail/DetailHeader';
import PhotoGalleryDetail from '../PhotoGallery/PhotoGalleryDetail/PhotoGalleryDetail';
import VideoDetail from '../Video/VideoDetail';
import VirtualTourDetail from '../VirtualTour/VirtualTourDetail';
import FadingContainer from '../FadingContainer/FadingContainer';

import '../Detail/Detail.scss';

const SubpaneMediaDetail = ({
  data,
}) => (
  <FadingContainer>
    <div id="mediaDetail">

      <DetailHeader
        title={data?.title}
      />

      <PhotoGalleryDetail
        id={data?.id}
        className="detailSection detailSection--gallery"
        uuid={null}
        images={data?.photoGalleryImages}
        galleryClass="slideshow"
        imageClass="slideshowPhoto"
      />

      <VideoDetail
        videoId={data?.video?.videoId}
        service={data?.video?.service}
        autoplay={false}
        className="detailSection"
      />

      <VirtualTourDetail
        uuid={null}
        threeSixtiesData={data?.threeSixties}
        className="detailSection detailSection--virtualTour"
      />

    </div>
  </FadingContainer>
);

export default SubpaneMediaDetail;
